export const FULL_DAY = 'yyyy-MM-dd';
export const TIME = 'HH:mm';
